// Notdienst.js – Notdienst-Sektion der Startseite: Vorzeile, Überschrift, Kurztext, Telefon-Button und Foto des Einsatzfahrzeugs.
// Das Kennzeichen im Foto ist übermalt (siehe images/Notdienst/amarok.webp). Stile: custom.css, Präfix ff-notdienst.
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import amarok from "./images/Notdienst/amarok.webp";
import betrieb, { telefonLink } from "../../data/betrieb";

function Notdienst() {
  return (
    <section className="ff-notdienst" aria-labelledby="notdienst-titel">
      <Container className="py-5">
        <Row className="align-items-center gy-4 gx-lg-5">
          <Col xs={12} lg={6}>
            <span className="ff-eyebrow">Sturmschaden oder Gefahrbaum?</span>
            <h2 className="ff-section-title" id="notdienst-titel">
              Notfall? Rufen Sie direkt an.
            </h2>
            <p className="ff-notdienst__text">
              Umgestürzte oder angebrochene Bäume, Äste über Straße, Haus oder Leitung: Rufen Sie mich auf dem
              Handy an. Bei akuter Gefahr komme ich, sobald es irgendwie geht, auch kurzfristig. Wo nötig, holt die
              Forstseilwinde den Stamm kontrolliert heraus. Erreichen Sie mich einmal nicht, sprechen Sie auf die
              Mailbox oder schreiben Sie kurz, ich melde mich schnellstmöglich.
            </p>
            <p className="ff-notdienst__nummer">
              Mobil: <strong>{betrieb.telefon}</strong>
            </p>
            <div className="ff-notdienst__actions">
              {/* Nummer nur einmal und in der Schreibweise aus betrieb.js (steht fett darüber), kein zweites Format im Button */}
              <a href={telefonLink} className="btn-ff-primary ff-notdienst__tel">
                Jetzt anrufen
              </a>
              <Link to="/baumfaellung" className="btn-ff-outline" onClick={() => window.scrollTo(0, 0)}>
                Mehr zur Baumfällung
              </Link>
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <img
              className="ff-notdienst__img"
              src={amarok}
              width={1200}
              height={677}
              loading="lazy"
              decoding="async"
              alt="Einsatzfahrzeug VW Amarok von Forst & Flur neben der funkgesteuerten Raupe mit Forstseilwinde"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Notdienst;
